import { REPORT_SERVICE_KEYS } from './reportEmailApi';

/** Sidebar service id → platform service_key for email API */
export const REPORTING_SERVICE_MAP = {
  execReport: REPORT_SERVICE_KEYS.EXECUTIVE,
  financeReport: REPORT_SERVICE_KEYS.FINANCE,
  denial: REPORT_SERVICE_KEYS.DENIAL_MANAGEMENT,
  claims: REPORT_SERVICE_KEYS.CLAIMS_PROCESSING,
  arPosting: REPORT_SERVICE_KEYS.AR_POSTING,
  charges: REPORT_SERVICE_KEYS.CHARGE_MANAGEMENT,
  priorAuth: REPORT_SERVICE_KEYS.PRIOR_AUTHORIZATION,
  eligibility: REPORT_SERVICE_KEYS.INSURANCE_VERIFICATION,
  remittanceAdvice: REPORT_SERVICE_KEYS.REMITTANCE_ADVICE,
  ediPlatform: REPORT_SERVICE_KEYS.EDI_PLATFORM,
  clearingHouse: REPORT_SERVICE_KEYS.EDI_PLATFORM,
  contractManagement: 'contract_management',
  patientBilling: REPORT_SERVICE_KEYS.PATIENT_BILLING,
  compliance: 'rcm_compliance',
};

const REPORT_LABELS = {
  'denial-summary': 'Denial Summary Report',
  'appeal-analysis': 'Appeal Analysis Report',
  'payer-performance': 'Payer Performance Report',
  'financial-impact': 'Financial Impact Report',
  'provider-performance': 'Provider Performance Report',
  'compliance-report': 'Compliance Report',
  'financial-summary': 'Financial Summary Report',
  'rejection-analysis': 'Rejection Analysis Report',
  'performance-metrics': 'Performance Metrics Report',
  'clean-claim-rate': 'Clean Claim Rate Report',
  'submission-performance': 'Submission Performance Report',
  'error-patterns': 'Error Patterns Report',
  'payment-analysis': 'Cash Posting Report',
  'auto-post': 'Auto-Post Report',
  'reconciliation-analysis': 'Deposit Reconciliation Report',
  'adjustment-analysis': 'Adjustment Analysis Report',
  'deposit-matching': 'Deposit Matching Report',
  underpayments: 'Underpayment Report',
  'charge-metrics': 'Charge Metrics Report',
  'missing-encounters': 'Missing Encounters Report',
  'charge-lag': 'Charge Lag Report',
  'revenue-summary': 'Revenue Summary Report',
  'code-review': 'Code Review Report',
  'authorization-summary': 'Authorization Summary Report',
  'patient-demographics': 'Patient Demographics Report',
  'audit-trail': 'Audit Trail Report',
  'edi-transaction-log': 'EDI Transaction Log',
  'verification-summary': 'Verification Summary Report',
  'benefits-analysis': 'Benefits Analysis Report',
  'patient-responsibility': 'Patient Responsibility Report',
  'coverage-status': 'Coverage Status Report',
  volume: 'RA Volume & Trends Report',
  status: 'Payment Status Report',
  financial: 'Financial Summary Report',
  processing: 'Processing Metrics Report',
  era: 'ERA Analytics Report',
  'payment-velocity': 'Payment Velocity Report',
  'reversal-rate': 'Reversal Rate Report',
  'payer-drift': 'Payer Drift Report',
  'transaction-log': 'Transaction Log Report',
  'success-rate': 'Success Rate Report',
  'error-analysis': 'Error Analysis Report',
  'contract-performance': 'Contract Performance Report',
  'payer-agreement-analysis': 'Payer Agreement Analysis',
  'fee-schedule-comparison': 'Fee Schedule Comparison',
  'contract-compliance': 'Contract Compliance Report',
  'revenue-impact': 'Revenue Impact Report',
  'billing-summary': 'Billing Summary Report',
  'payment-collection': 'Payment Collection Report',
  'outstanding-balance': 'Outstanding Balance Report',
  'payment-plan-analysis': 'Payment Plan Analysis',
  'executive-kpi-snapshot': 'Executive KPI Report',
  'saved-reports': 'Saved Executive Report',
  'compare-reports': 'Executive Report Comparison',
  'finance-view-summary': 'Finance View Summary',
  'vs-ehr-variance': 'vs EHR Variance Report',
  'capture-unmatched': 'Capture & Unmatched Lists',
  'dollars-at-risk': 'Dollars at Risk Report',
  'executive-compliance': 'Executive Compliance Summary',
  'risk-register': 'Risk Register & Hotspots',
  'audit-workpack': 'Audit Workpack',
};

export function getReportCatalogEntry(activeService, activeReport) {
  if (!activeService) return null;
  const serviceKey = REPORTING_SERVICE_MAP[activeService] || activeService;
  const reportName =
    (activeReport && REPORT_LABELS[activeReport])
    || (activeReport ? activeReport.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : 'Report');
  return {
    service_key: serviceKey,
    report_name: reportName,
    report_id: activeReport || null,
    service_id: activeService,
  };
}
